<template>
  <v-btn
    class="preview-button"
    @click="handleAnimate"
    :title="title"
    size="small"
    variant="tonal">
    <v-icon size="x-large">mdi-play</v-icon>
  </v-btn>
</template>
<script setup>
import { $http } from '../../../stores/http';

const props = defineProps(['channelUUID', 'title']);

const animateURL = `/dynamic_engine/animate_preview/${props.channelUUID}`;
async function handleAnimate() {
  await $http('GET', animateURL);
}
</script>
<style scoped>
.preview-button[disabled] {
  cursor: not-allowed;
  cursor: default;
  pointer-events: auto;
}
</style>
